import React, { PureComponent } from 'react';
import DownloadPdf from 'wt-react/dist/components/DownloadPdf/DownloadPdf';
import './App.css';
import {UNKNOWN_EMAIL} from '../../index.js';

const queryString = require('query-string');

class App extends PureComponent {
  
  render() {

    const {
      params,      
    } = this.props;

    const queryParams = queryString.parse(window.location.search, {arrayFormat: 'index'});

    console.log(queryParams);

    // Get email from query params
    let email = UNKNOWN_EMAIL;
    if (queryParams && queryParams.email){
      email = queryParams.email;
    }

    // Get the adhoc inputs
    let adhocInputs;
    if (queryParams && queryParams.names && queryParams.names && queryParams.names.length === queryParams.values.length){

      adhocInputs = queryParams.names.map( (name, index) => {

        return {
          "name": name,
          "value": queryParams.values[index],
        }

      })
    }

    // Get configID from query params
    let configId;
    if (queryParams && queryParams.configId) {
      configId = queryParams.configId;
    }

    return (
      <div className="app">

        {/* Show the download pdf component */}
        <DownloadPdf 
              token={params.token}
              clientEmail={params.clientEmail && params.clientEmail !== UNKNOWN_EMAIL ? params.clientEmail : email}
              configId={configId ? configId : params.configId}
              initialButtonText={params.buttonText}
              dataspanApiUrl={params.dataspanApiUrl}
              dpdApiUrl={params.dpdApiUrl}
              adhocInputs={adhocInputs ? adhocInputs : params.adhocInputs}
              submitOnLoad={false}
              isAnonymous={params.isAnonymous}
              openModalOnLoad={params.openModalOnLoad}
            />

      </div>
    );
  }
}

export default (App);
